import { OedsPerson, EmailList, PhoneList, AddressList, oedsEmailTypeKeys, oedsPhoneTypeKeys, oedsAddressTypeKeys, oedsLocationTypeKeys, OrgEmailList } from '../models/contact-oeds-person.model';
import { MdmPerson } from '../models/contact-mdm-person.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ContactMappingService {

  mapContactDtlsModel(mdmPersonObj: MdmPerson, oedsPersonObj: OedsPerson) {
    //Oeds Person Key
    oedsPersonObj.oedsPersonKey = mdmPersonObj.identifierList.find(obj => obj.identifierType.name == "PERSON_KEY").identifierValue;

    const uniqueOrgList = [...new Set(mdmPersonObj.organizationRoleMemberList.map(item => item.organizationKey))];
    //Map Org emil List
    if (uniqueOrgList.length > 1) {
      for (const item of uniqueOrgList) {
        let sOrg=mdmPersonObj.organizationRoleMemberList.find(x => x.organizationKey == item);
        const oedsOrgEmailsObj = {} as OrgEmailList;
        oedsOrgEmailsObj.orgKey = sOrg.organizationKey;
        oedsOrgEmailsObj.oedsOrgKey = sOrg.oedsOrgKey;
        oedsOrgEmailsObj.email = "";
        oedsPersonObj.orgEmailList.push(oedsOrgEmailsObj);       
      }
    }

    if (mdmPersonObj.emailList) {
      //Oeds Email List
      for (const item of mdmPersonObj.emailList) {
        const oedsEmailObj = {} as EmailList;
        oedsEmailObj.oedsEmailKey = item.oedsEmailKey;
        oedsEmailObj.email = item.emailAddress;
        oedsEmailObj.oedsEmailType = this.getOedsEmailTypeKey(item.emailType.name);        
        oedsEmailObj.primaryFlag = item.primaryFlag;
        oedsEmailObj.privateFlag = item.privateFlag;
        oedsEmailObj.exEmail = item.emailAddress;
        oedsEmailObj.actionType = "";        
        if (item.organizationKeys.length != 0) {
          for (const oKey of item.organizationKeys) {
            let currentOrgMapping = oedsPersonObj.orgEmailList.find(obj => obj.orgKey == oKey);
            if (currentOrgMapping) {
              currentOrgMapping.email = item.emailAddress;
              currentOrgMapping.oedsEmailKey = item.oedsEmailKey;
            }
          }
          oedsEmailObj.isMapped = true;
        }
        else {
          oedsEmailObj.isMapped = false;
        }
        oedsPersonObj.emailList.push(oedsEmailObj)
      }
    }
    if (mdmPersonObj.phoneList) {
      //Oeds Phone List
      for (const item of mdmPersonObj.phoneList) {
        const oedsPhoneObj = {} as PhoneList;
        oedsPhoneObj.oedsPhoneKey = item.oedsPhoneKey;
        oedsPhoneObj.phoneNumber = item.phoneNumber.trim();       
        oedsPhoneObj.areaCode = item.areaCode.trim();
        oedsPhoneObj.oedsPhoneType = this.getOedsPhoneTypeKey(item.phoneType.name);
        oedsPhoneObj.primaryFlag = item.primaryFlag;
        oedsPhoneObj.privateFlag = item.privateFlag;
        oedsPhoneObj.actionType = "";
        if (item.areaCode.trim() === "") //If empty phone from DB we are marking that for deletion
          oedsPhoneObj.actionType = "Deleted";
        else
          oedsPhoneObj.phoneNumberDisplay = item.phoneNumber.substring(0, 3) + "-" + item.phoneNumber.substring(3, 7)
        oedsPersonObj.phoneList.push(oedsPhoneObj)
      }
    }
    if (mdmPersonObj.addressList) {     
      //oeds Adddress List
      for (const item of mdmPersonObj.addressList) {
        const oedsAddressObj = {} as AddressList;
        oedsAddressObj.oedsAddressKey = item.oedsAddressKey;
        oedsAddressObj.addressI = item.addressI;
        oedsAddressObj.city = item.city;
        oedsAddressObj.stateKey = item.state == null ? 0 : item.state.key;
        oedsAddressObj.state = item.state == null ? "" : item.state.name;
        oedsAddressObj.zipCode = item.zipCode;
        oedsAddressObj.zipCode4 = item.zipCode4
        oedsAddressObj.oedsLocationType = this.getOedLocationTypeKey(item.addressType.name.split(" ")[0]);
        oedsAddressObj.oedsAddressType = this.getOedAddressTypeKey(item.addressType.name.split(" ")[1]);        
        oedsAddressObj.isConfirm = false;
        oedsAddressObj.actionType = "";
        if (item.addressI === "") //If empty address from DB we are marking that for deletion
          oedsAddressObj.actionType = "Deleted";       
        oedsPersonObj.addressList.push(oedsAddressObj)
      }
    }
  }

  getOedsEmailTypeKey(name) {
    switch (name) {
      case 'Home': return oedsEmailTypeKeys.Home;
      case 'Office': return oedsEmailTypeKeys.Office;
      default: return 0
    }
  }
  getOedsPhoneTypeKey(name) {
    switch (name) {
      case 'Office': return oedsPhoneTypeKeys.Office;
      case 'Home': return oedsPhoneTypeKeys.Home;
      case 'Cell': return oedsPhoneTypeKeys.Cell;
      case 'Mobile': return oedsPhoneTypeKeys.Mobile;
      default: return 0
    }
  }
  getOedAddressTypeKey(name) {
    switch (name) {
      case 'Physical': return oedsAddressTypeKeys.Physical;
      case 'Mailing': return oedsAddressTypeKeys.Mailing;
      default: return 0
    }
  }
  getOedLocationTypeKey(name) {
    switch (name) {
      case 'Home': return oedsLocationTypeKeys.Home;
      case 'Office': return oedsLocationTypeKeys.Office;
      default: return 0
    }
  }
}
